// apps/LeadForm/index.js
// Yuan Wang
// Copyright American Marine Research Company LLC 2019

import React, { Fragment, useState } from 'react';

import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { Button } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';
import FormHelperText from '@material-ui/core/FormHelperText';
import { validateEmail } from '../../helpers'
import addToMailchimp from 'gatsby-plugin-mailchimp'

export const RETAILER_FORM_NAME = 'retailer_interest_v1'
export const GENERAL_INTEREST_FORM_NAME = 'general_interest_v1'
export const CLOSET_INTEREST_FORM_NAME = 'closet_interest_v1'
export const PERKS_FORM_NAME = 'perks_interest_v1'

// MC
export const DEFAULT_ENDPOINT =   "#"
export const CLOSET_ENDPOINT =    "#"
export const RETAILER_ENDPOINT =  "#"

// TODO: move all config here, then emit preconfigured forms for export. 
export const FORM_DATA_CONFIG = {
  [RETAILER_FORM_NAME]: {
    endpoint: DEFAULT_ENDPOINT
  },
  [GENERAL_INTEREST_FORM_NAME]: {
    endpoint: DEFAULT_ENDPOINT
  },
  [CLOSET_INTEREST_FORM_NAME]: {
    endpoint: CLOSET_ENDPOINT
  },
  [PERKS_FORM_NAME]: {
    endpoint: DEFAULT_ENDPOINT
  }
}

const useStyles = makeStyles((theme) => 
  createStyles({
    container: {
      margin: 0,
      padding: 0,
    },
    textField: {
      flexGrow: 1,
      margin: 0,
      padding: 0,
      marginBottom: theme.spacing(1),
      boxShadow: theme.shadows[5],
      borderRadius: theme.shape.borderRadius
    },
    inputContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      paddingBottom: theme.spacing(2),
      // paddingRight: theme.spacing(2),
      fontSize: 'inherit',
    },
    buttonContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
    },
    button: {
      marginTop: 0,
      height: 56,
      boxShadow: theme.shadows[5],
    },
    br: {
      height: 1,
      width: theme.spacing(2)
    },
    whiteText: {
      color: 'white'
    }, 
    error: {
      color: theme.palette.error.main
    },
    fmh: {
      position: 'absolute',
      left: "-5000px"
    }
  })
)

export default function Form({ action, method, name, target, endpoint, prompt, description, formName, callToAction, netlify, mailchimp }) {
  const classes = useStyles()
  const [ email, setEmail ] = useState("")
  const [ field, setField ] = useState("")
  const [ error, setError ] = useState(false)
  const [ comment, setComment ] = useState(null)
  name = name || formName
  endpoint = endpoint || (name && FORM_DATA_CONFIG[name] && FORM_DATA_CONFIG[name].endpoint) || DEFAULT_ENDPOINT
  const valid = validateEmail(email)

  console.log(endpoint, name)

  const onSubmit = async () => {
    if (!validateEmail(email)) {
      setComment("Hmm, check your email?")
      setError(true)
      return false
    }

    if (field) {
      return false
    }
    //
    if (mailchimp) {
      await submitMailchimp()
    }
  }

  const submitMailchimp = async () => {
    try {
      const listFields = { 'form_name': name }
      const { result, msg } = await addToMailchimp(email, listFields, endpoint)
      if (result === 'success') {
        setComment("Nice!")
        setError(false)
        window.location.href = action
        return true
      }
      else {
        if (msg.includes("already subscribed")) {
          setComment("Already subscribed")
        }
        else {
          setComment("Hmm, something went wrong. Try again or contact support.")
        }
        setError(true)
        return false
      }
      
    } catch(error) {
      setComment("Hmm, something went wrong. Try again or contact support.")
      setError(true)
      return false
    }
  }

  return (
    <Container maxWidth="md" className={classes.container}>
      <form 
        name={name} 
        method={method}
        action={action}
        onSubmit={onSubmit}
        data-netlify={ netlify ? "true" : null }
        target={target}
        data-netlify-honeypot={ netlify ? "bot-field" : null }
        >
        <div className={classes.fmh} aria-hidden="true">
          <input 
            onChange={(e) => setField(e.target.value)} 
            type="text" 
            name="b_b65be31ac5aaee261d4390f82_966ebad2e5" 
            tabIndex="-1" 
            value={field}/>  
        </div>
        <input type="hidden" name="form-name" value={name} />
        <Grid container spacing={0} className={classes.container}>
          <Grid item xs={12} sm={7} className={classes.inputContainer}>
            <TextField
              name="email"
              className={classes.textField}
              label={prompt}
              // margin="normal"
              onChange={(e) => setEmail(e.target.value)}
              variant="outlined"
            />  
            <FormHelperText 
              color="inherit"
              className={ error ? classes.error : "" }
              id="email">
              { comment || description }
            </FormHelperText>
          </Grid>
          <Grid item className={classes.br}>
            <br/>
          </Grid>
          <Grid item xs={12} sm={4} className={classes.buttonContainer}>
            <FormControl>
              <Button 
                fullWidth
                size="large"
                color="secondary" 
                variant="contained"
                name={ valid && netlify ? "submit" : "button" }
                onClick={ netlify ? (valid ? null : onSubmit) : onSubmit }
                type={ valid && netlify ? "submit" : "button" }
                // href={href}
                // disabled={!validateEmail(email)}
                value="Send Message"
                className={classes.button}>
                <Typography variant="h6" className={classes.whiteText}>
                { callToAction }
                </Typography>
              </Button>
            </FormControl>
          </Grid>
        </Grid>
      </form>
    </Container>
  );
}

Form.defaultProps = {
  action: "/thanks",
  prompt:"Your very best email",
  callToAction:"Let's Talk!",
  formName: GENERAL_INTEREST_FORM_NAME,
  method: "POST",
  // target: "_blank",
  netlify: false,
  mailchimp: true,
}